// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2kdp6","resendInfoText":"OnGoingPaymentBox_resendInfoText__Kj5ka"};